import React from "react";
import { NavLink } from "react-router-dom";
import { Home, ArrowLeftRight, Wallet, LineChart, Settings } from "lucide-react";

const items = [
  { to: "/", label: "Inicio", icon: Home, testid: "nav-inicio" },
  { to: "/movimientos", label: "Movimientos", icon: ArrowLeftRight, testid: "nav-movimientos" },
  { to: "/cuentas", label: "Cuentas", icon: Wallet, testid: "nav-cuentas" },
  { to: "/proyeccion", label: "Proyección", icon: LineChart, testid: "nav-proyeccion" },
  { to: "/configuracion", label: "Ajustes", icon: Settings, testid: "nav-configuracion" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-30"
      data-testid="bottom-navigation"
    >
      <div
        className="fp-glass border-t border-line/80 px-3 pt-2"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 0.75rem)" }}
      >
        <ul className="flex items-center justify-between">
          {items.map(({ to, label, icon: Icon, testid }) => (
            <li key={to} className="flex-1">
              <NavLink
                to={to}
                end={to === "/"}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 py-1.5 rounded-xl transition-colors ${
                    isActive ? "text-sage-900" : "text-soft hover:text-ink"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <div
                      className={`flex items-center justify-center transition-all ${
                        isActive ? "scale-110" : "scale-100"
                      }`}
                    >
                      <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                    </div>
                    <span
                      className={`text-[10px] tracking-wider uppercase ${
                        isActive ? "font-bold" : "font-medium"
                      }`}
                    >
                      {label}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
